<template>
    <div class="gatewayPage">
        <v-left ref="treeLeft" @changeWay="changeWayFn" />
        <div style='width: calc(100% - 300px)'>
            <div class="device-status-desc">
                {{ $t(deviceStatusButton[sensorWay].title) }}
            </div>
            <div style="height: calc(100% - 50px);">
                <components :selectDeviceType="selectDeviceType" :is="sensorWay" :sensorWay="sensorWay" :deviceGateWayType="deviceGateWayType" ref="componentContent"></components>
            </div>
        </div>
        <i class="iconfont icon-excel question excel" :title="$t('integration.export_template')" v-show="sensorWay === 'unknown'" @click="loadFileFn"></i>
        <div class="question">
            <IconDesc :iconDesc="gatewayIconDesc"></IconDesc>
        </div>
        <gatewayDetail :way='sensorWay' :show.sync="gatewayDetailShow"></gatewayDetail>

        <!-- 协调器弹框 -->
        <gatewayDetail :bus-key="'coordinatorParam'"></gatewayDetail>
    </div>
</template>

<script>
import leftTree from './components/leftTree.vue'
import bindPage from './bind/bindPage.vue'
import unBindPage from './unbind/UnBindPage.vue'
import stopPage from './stop/stopPage.vue'
import unknowPage from './unknow/UnKnowPage.vue'
import IconDesc from '@/components/IconDesc/IconDesc.vue'
import gatewayIconDesc from './config/gatewayIconDesc'
import gatewayDetail from '@/components/dialog/gatewayDetail/gatewayDetailDialog.vue'
import { getGeneraUploadTemplateFile } from '@/api/modules/deviceUrl.js'
import pleaseSelect from '@/common/pleaseSelect'
import bus from '@/utils/bus.js'
import { deviceStatusButton, deviceTypeListConvert } from '@/utils/convert'
import { getPermission } from '@/utils/permission'
import { ENUM_DEVICE_WAY } from '@/common/enum/forward/device'
export default {
  components: {
    'v-left': leftTree,
    [ENUM_DEVICE_WAY.BIND]: bindPage,
    [ENUM_DEVICE_WAY.UNBIND]: unBindPage,
    [ENUM_DEVICE_WAY.STOP]: stopPage,
    [ENUM_DEVICE_WAY.UNCONFIRM]: unknowPage,
    IconDesc,
    gatewayDetail
  },
  computed: {
    deviceStatusButton: () => deviceStatusButton,
    /** 用于表示当前登录用户属于什么类型的角色 */
    sysAdmin () {
      return getPermission()
    },
    gatewayIconDesc: () => gatewayIconDesc
  },
  data () {
    return {
      sensorWay: ENUM_DEVICE_WAY.BIND,
      deviceGateWayType: [],
      selectDeviceType: [],
      gatewayDetailShow: false
    }
  },
  created () {
    this.getInitDeviceData()
  },
  mounted () {
    this.$store.dispatch('device/getGatewayType', { select: true }).then(res =>
      this.deviceGateWayType
    )
  },
  methods: {
    // 获取网关类型 -- 说明以后这种类型但凡后台添加一个  前端这里直接添加多一个静态数据就可以了  不需要再去传递值给其他组件 这里的值 只需要给未确认的新增哪里就行了
    getInitDeviceData () {
      this.$store.dispatch('device/getGatewayType').then(res => {
        // 在这里重新把label字段国际化一下吧，本来应该在utils/matchDeviceType文件国际化更好，但是报错，不知道怎么做
        res.forEach(item => {
          item.label = deviceTypeListConvert[item.code]
        })
        this.selectDeviceType = [pleaseSelect, ...res]
        this.deviceGateWayType = res
      })
    },
    loadFileFn () {
      getGeneraUploadTemplateFile('gateway', this.$i18n.locale).then(res => {})
    },
    changeWayFn (item) {
      console.log(item)
      this.$refs.treeLeft.filterText = null
      const { way } = item
      this.sensorWay = way
      // 重置左侧树形搜索条件
      if (way === ENUM_DEVICE_WAY.UNBIND || way === ENUM_DEVICE_WAY.UNCONFIRM) {
        this.$refs.componentContent.SearchForm.scopeName = this.$store.getters.SchemaTree[0].label
      } else {
        this.$refs.componentContent.SearchForm.scopeName = null
      }
      this.$refs.componentContent.SearchForm.sceneId = null
      //  this.$refs.componentContent.getListFn();
      /** 抛出一个方法修改树形结构数据 醉了 */
      bus.$emit('editTree', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.gatewayPage {
    height: 100%;
    display: flex;
    position: relative;

    .rightDropdown {
        position: absolute;
        right: 15px;
        top: 0px;
    }

    .question {
        position: absolute;
        right: 15px;
        top: 67px;
        font-size: 18px;
        cursor: pointer;
        color: #9bccfd;

        &:hover {
            color: var(--primary-color);
        }
    }

    .excel {
        right: 40px;
    }
}

.rightPage {
    flex: 1;
    height: 100%;
    //padding: 0 15px;
    overflow: auto;
    //border-left: 1px solid $borderColor3;
    box-sizing: border-box;
}
</style>
